<template>

    <div id="app" class="container" data-app>



        <div class="row">


<!--           <div id="hero-main-img" class="col-12 col-lg-7 order-2 order-lg-1">
                <img src="static/hero-smile.png">
          </div>


 -->
          



          <div class="col-12 col-lg-7 order-2 order-lg-1 ">



<!--             <div v-if="loggedIn" class="d-block d-lg-none col-lg-4 mb-5 order-2 order-lg-2">


              <CalcSlider endpoint="" />

            </div> -->



            <div class="main-col ">

              <div class="container">
                    <div class="row">
                        <div class="col">



                          <div v-if="formErrors" class="col-12 alert alert-danger" >
                            <p>Niektóre pola formularza są niepoprawnie wprowadzone.</p>

                            <ul>
                              <li v-for="field in invalidFields" > {{ field }} </li>
                            </ul>
                          </div>



                            <!-- 1 STEP HEADER -->
                            <!-- <div v-if="activeStep == 1 && !formErrors">

                               <div class="row justify-content-between  d-md-flex">
                                <div class="col-auto me-auto">
                                  <h2>Mam już konto</h2>
                                </div>
                                <div class="col-auto">
                                  <a id="przycisk" class="login-button btn btn-outline-primary btn-lg me-2" data-bs-toggle="modal" data-bs-target="#loginDialog" @click="">Zaloguj się </a>
                                </div>
                              </div> 

                              <hr class=" d-none d-md-flex"/> 


                              <div class="row mb-2  d-none d-md-flex" style="text-transform:uppercase; color:#585858;">
                                <div class="col-12 col-xl-auto me-auto" >
                                  <h2 style="color:#585858;">Rejestracja konta</h2>
                                </div>
                                <div class="col-12 col-xl-auto text-xl-end">
                                  <p>Jesteś nowym klientem?<br/>Prosimy o <b>wypełnienie danych poniżej</b>.</p>
                                </div>
                              </div>
                            </div>  -->




                            <!-- inputs -->
                            <div v-for="(item, idx) in stepForm" class="row">


                              <DynamicField

                                v-if="!String(idx).match(/^__row|__goto|__cmp|__endpoint|__wait|__amount/)"

                                :key="idx"
                                :name="idx"

                                :element="item"

                                :filled="isFilled"

                                :vuelidator="$v.form[ idx ]"

                                :form="form"
                              />

                              <DynamicField

                                v-if="String(idx).match(/^__row/)"

                                v-for="(element, name, index) in item"

                                :count="Object.keys(item).length"

                                :key="name"
                                :name="name"
                                :index="index"

                                :element="element"

                                :filled="isFilled"

                                :vuelidator="$v.form[ name ]"


                                :form="form"
                              />

                              <BlockTitle
                                v-if="String(idx).match(/^__cmp_BlockTitle/)"
                                :element="item"
                                :name="idx"
                              />


                            </div>




                            <!-- VERIFY CODE -->
                            <div class="row" v-if="String( specialStep ).match(/^verifycode/)" >


                              <div class="col-lg-12"><h3> Wprowadź kod SMS </h3></div>

                              <div class="col-lg-6 form-input">


                                <input type="text" class="form-control" placeholder="Kod SMS" v-mask="'NNNNNN'"  v-model="form['verifycode']" @input="$emit('input', $event.target.value); $v.form['verifycode'] && $v.form['verifycode'].$touch()"
                                       :class="{
                                            'is-valid': $v.form['verifycode'] && !$v.form['verifycode'].$invalid && $v.form['verifycode'].$dirty,
                                            'is-invalid': $v.form['verifycode'] && $v.form['verifycode'].$invalid && $v.form['verifycode'].$dirty
                                        }"
                                >

                                <div class="invalid-feedback" v-if="$v.form['verifycode'] && verifycode_hint && $v.form['verifycode'].$invalid && $v.form['verifycode'].$dirty">{{ verifycode_hint }}</div>

                              </div>
                            </div>




                            <!-- KONTOMATIK -->
                            <div class="row" v-show="String( specialStep ).match(/^kontox/)">
                              <div class="col-lg-12"><hr class="d-none d-md-flex"> <h3 style="padding: 1rem 0.5rem;"> Wybierz swoje główne konto abyśmy mogli je zweryfikować, na to konto wyślemy Ci Twoją pożyczkę. Pamiętaj aby było to Twoje główne konto na które przelewane jest np. Twoje Wynagrodzenie. Weryfikacja tego konta ma wpływ na Twoją zdolność kredytową. </h3></div>
                              <div id="kontox" class="column col-12 d-flex justify-content-center"></div>
                            </div>






                            <div class="row py-3 justify-content-end">


                              <div class="col-auto">

                                <a key="btn-prev"  v-if="activeStep > 1 && activeStep < 3 && !String( specialStep ).match(/^kontox/) && !isFilled" class="button btn-prev btn btn-outline-primary btn-lg me-2" @click="prev" ><i class="icon flaticon-left-arrow"></i> COFNIJ </a>


                                <a  key="btn-filldbg"  v-if="debug == 'on' && activeStep <= steps "
                                  class="button btn-prev btn btn-outline-primary btn-lg me-2"
                                  @click="filldebug" > DEBUG </a>


                                <a  key="btn-next"  v-if="activeStep <= steps && !String( specialStep ).match(/^kontox/)" :class="{
                                  disabled:$v.form.$invalid
                                }"
                                class="button btn-next  btn btn-outline-primary btn-lg me-2"
                                @click="next" > DALEJ <i class="icon flaticon-right-arrow"></i></a>




<!-- 

            <input type="button"  key="btn-axios" class="button btn-prev" @click="testroute" value="test" />

  

 -->


                              <!--  <a key="btn-submit"
                                          @click.prevent="onSubmit"
                                          type="submit"

                                          v-if="activeStep === steps"

                                          :disabled="$v.form.$invalid"

                                          class="form-button btn btn-outline-primary btn-lg me-2 "
                                  >WYŚLIJ <i class="icon flaticon-right-arrow"></i></a>
                                -->


                                

                                </div>


                            </div>



                      <div v-if="debug == 'on'"  class="row">
                        <div class="debug_btn" @click="filldebug" >debug</div>
                        <div class="debug_btn" @click="doNextStep" >next</div>


                       <!--  <div  class="debug_btn" @click="resetKontox" >setup kontox</div>
                        <div  class="debug_btn" @click="testKontox" >do kontox</div>
   -->

                        <pre>


                        {{'step is ' + activeStep}}

                        {{loanAmount + ' ' + loanTenor + ' ' + tenorSign}}

                        {{ 'tenor ' + tenorSign }}
                 

                         {{form}}
       

<!--                          {{dynamicValidation}}

                         {{$v}}  -->

                        </pre>

                      </div>







                  </div>
                </div>
              </div>
            </div>

          </div>




          <div class="col-12 col-lg-5 order-1 order-lg-2 ">
      

            <CalcSlider  endpoint="" />
    

          </div>





        </div>

<!--
        <pre>
         {{ loanAmount }}
        </pre> -->


<!-- 
        <pre>
         {{$v}}
        </pre>

 -->
<!-- 
        <pre>{{ form }}</pre>

   -->




    </div>
</template>

<script>

import __form_config from './conf/form_config.json';

//import { validationMixin } from 'vuelidate';

import { url, alpha, email, required, minLength, maxLength, sameAs } from 'vuelidate/lib/validators';

import { validatePolish } from 'validate-polish';

import DynamicField from '@/components/DynamicField';
import BlockTitle from '@/components/BlockTitle';
import SignContract from '@/components/SignContract';
import CalcSlider from '@/CalcSlider';




export default {
  name: 'DynamicForm',
  components: { DynamicField, BlockTitle, SignContract, CalcSlider},


  props: {            
      form: {
          type: Object,
          required: true
      }
  },



  data() {
    return {

      debug: this.getConf('debug'),
      tests: this.getConf('tests'),
      

      page: null,
      fmap: null,

      fillDone: false,
      delayedTask: null,



      activeStep: 1,

      activeFields: null,

      steps: 1,
      schema: [{}],

      verifycode_hint: '',

      formErrors: false,

      invalidFields: [],

      isFilled: false,

      isRegisterLink: false,

      isSubmitting: false,
      lastSubmitTime: 0,

      // tryb OTP: zapis kroku 1 (__initial) odlozony do czasu poprawnego kodu SMS
      // (incydent 2026-10-07: zmieniony numer trafial do GATEWAY przed weryfikacja)
      otpPendingSubmit: false,
      otpSubmitAfterVerify: false,

      // anti-tamper (log 1781087182): kwota faktycznie zapisana na wznawianym
      // wniosku, odtworzona z /client/loans. W trybie __edit payload bierze ją
      // zamiast lokalnej (domyslnej/podmienionej w devtools) loanAmount.
      continuationAmount: null,
      continuationInstallments: null,


      // status calls
      waiting: '',
      waitCount: 0,


      persistItems: {},

      appendFields: {},


      editMode: 'persist',


      dynamicValidation: {},



      uri: ''
    }
  },

  computed: {

    loggedIn(){

      return this.$root.mainpage.loggedIn;

    },

    installmentAmount(){


      return (this.loanAmount / this.loanTenor).toFixed(2);
    },



    specialStep(){

      return this.schema[ this.activeStep-1 ].hasOwnProperty('__goto') ? this.schema[ this.activeStep-1 ].__goto : false;
    },


    stepForm() {



      let fields = this.schema[ this.activeStep-1 ],
          newSet = this.activeFields != fields;


      this.activeStep == 1 && this.$router.currentRoute.path != '/'
        && this.$router.push({path: '/'});

      // set route
      newSet && this.activeStep > 1 && this.activeStep < 4
          && this.$router.push({path: ['quickform','verifycode','fullform'][ this.activeStep-1 ]});


      if (this.schema[ this.activeStep-1 ].hasOwnProperty('__goto')) {
        return {};
      }
 
      
      // filter
      newSet && (this.appendFields = {}) && Object.keys( this.persistItems ).map( a => {

        if (!this.form.hasOwnProperty(a) || !this.form[a]) {

          this.appendFields[a] = this.persistItems[a];
        }

      });



      // iterate persist keys
      Object.keys( fields ).map( k => {

        if (k.match(/_persist$/)) {

          Object.keys( fields[k] ).map( e => {

            //if ( !fields[k][e].hasOwnProperty('vuelidation') || !fields[k][e].vuelidation.hasOwnProperty('accepted') ) {

              this.persistItems[ e ] = fields[k][e];
            //}

          });
            
          this.appendFields = {};
        }
      });



      this.activeFields = fields;

      


//console.log(fields);
//console.log(this.appendFields);



      return { ...fields, ...this.appendFields };
    },


    validationRules() {

      //console.log(this)

      let rules = {},
          step = this.stepForm, //  this.schema[ this.activeStep-1 ],
          form = this.form,


          addValidation = (r, step, force=false) => {


            if (step.hasOwnProperty(r) && step[ r ].hasOwnProperty('vuelidation') && (!step[ r ].hasOwnProperty('hidden') || force)) {


              rules[ r ] = {};


              let def = step[r].vuelidation;



              for (let idx in def) {


                if (def.hasOwnProperty(idx)){


                  switch (idx) {

                    case 'required':

                      rules[r].required = required;


                      break;

                    case 'accepted':

                      rules[r].accepted = v => {


                        //console.log('accepted - ' + v);

                        return v === true;
                      }
                      break;

                    case 'yesno':                    

                      var wrap = (function() {
                        var state = null;                     

                        return { // public in
                          yesno: v => {

                            if (typeof v != 'boolean') {

                              state = v === 'yes' || v === 'no';
                            }

                            return state;
                          }
                        };
                      })();

                      // assign to main model field 
                      //rules[ r ].yesno = wrap.yesno;
                      
                      // assign to helper model field
                      rules[ r + '_yesno' ] = {};
                      rules[ r + '_yesno' ].yesno = wrap.yesno;       
                      
                      break;

                    case 'email':

                      rules[r].email = email;
                      break;

                    case 'minLength':

                      rules[r].minLength = minLength(def[ idx ]);
                      break;

                    case 'maxLength':

                      rules[r].maxLength = maxLength(def[ idx ]);
                      break;

                    case 'sameAs':
                      rules[r].sameLike = sameAs(def[ idx ]);
                      break;

                    case 'alpha':
                      rules[r].alpha = alpha;
                      break;

                    case 'passwordPolicy':
                      rules[r].passwordPolicy = v => {
                      return this.passwordPolicy(v)
                      };
                      break;

                    case 'iban':
                      rules[r].iban = v => this.isValidIBAN(v);
                      break;

                    case 'mobile':
                      rules[r].mobile = v => this.isPlMobile(v);
                      break;

                    case 'names':
                      rules[r].names = v => /^[A-Za-z-zżźćńółęąśŻŹĆĄŚĘŁÓŃ]+$/.test(v);
                      break;   

                    case 'street':
                      rules[r].street = v => /^[A-Za-z0-9-zżźćńółęąśŻŹĆĄŚĘŁÓŃ\/ ]+$/.test(v);
                      break;  

                    case 'building':
                      rules[r].building = v => /^[A-Za-z0-9\/]+$/.test(v);
                      break; 

                    case 'latin':
                      rules[r].latin = v => /[A-Za-zzżźćńółęąśŻŹĆĄŚĘŁÓŃ]/.test(v) && !/[\d]/.test(v);
                      break;

                    case 'pesel': 
                      rules[r].pesel = validatePolish.pesel;
                      break;

                    case 'minValue': 
                      rules[r].minValue = v => parseInt( v ) >= parseInt(def[ idx ])
                      break;


                    case 'sexPesel': 
                      rules[r].sexPesel = v => {

                        let a = [1,0], eq = a.indexOf(v) ? a[v] : null;
                       
                        return !!form[ def[ idx ] ] && form[ def[ idx ] ].length == 11 && form[ def[ idx ] ][9] % 2 === eq;
                      };
                      break;






                    default:
                  }
                }
              }
            }
          };




      // include dynamic fields
      //step = {...step, ...this.dynamicValidation};



      for (let r in step ) {

        if (String(r).match(/^__row/)) {

          for (let i in step[r]) {

            addValidation(i, step[r]);
          }

        }
        else {

          addValidation(r, step);
        }
      }


      // set dynamic validations
      Object.keys(this.dynamicValidation).map( k => {

        addValidation(k, this.dynamicValidation, true);
      } );


      if (this.specialStep == 'verifycode') {

        rules['verifycode'] = {
          minLength: minLength(4),
          maxLength: maxLength(4),
          required: required
        }
      }

      return rules;
    }
  },

  validations() {

    return {
      form: this.validationRules
    }
  },


  //
  //              METHODS
  //
  methods: {






    postKontoxData(kontoxData= null) {

       var page = this.$root.mainpage;


        if (!!kontoxData) {

          this.waiting = 'application';
          this.waitCount = 0;

          page.isLoading = ['Analizujemy Twój wniosek...', 'To może potrwać kilka minut – prosimy o cierpliwość...', 'Trwa weryfikacja danych...', 'Już pracujemy nad decyzją...', 'Proszę nie zamykać przeglądarki...', 'Jeszcze chwila...'];

          this.post( '/bank', kontoxData)
          .then(response => {

            page.isLoading = !!this.waiting;

            if (!!response.data) {
              let ok = !(response.data.IS_ERROR | 0),
                  stage = response.data.stage || 'done';


              this.nextCB( ok, stage );
            }
          })
          .catch(error => {

              page.isLoading = false;

              // Error
              if (error.response) {
                  /*
                   * The request was made and the server responded with a
                   * status code that falls out of the range of 2xx
                   */
                  /*console.log(error.response.data);
                  console.log(error.response.status);
                  console.log(error.response.headers);*/

              } else if (error.request) {
                  /*
                   * The request was made but no response was received, `error.request`
                   * is an instance of XMLHttpRequest in the browser and an instance
                   * of http.ClientRequest in Node.js
                   */
                  //console.log(error.request);
              } else {
                  // Something happened in setting up the request and triggered an Error
                  //console.log('Error', error.message);
              }
          });
        }
    },



    verifyCode() {

       var page = this.$root.mainpage;


        //this.$v.form['verifycode'].$touch();

        if (String(this.form.verifycode).length > 0) {




          this.waiting = '';
          this.waitCount = 0;

          page.isLoading = true;


          this.log( '- VERIFY CODE BY ACTIVATE - ' + this.form.verifycode );



          this.post( '/activate', {

            client_email: this.form.client_email,
            activation_code: this.form.verifycode,
            // klucz pliku stanu <sid>.verified w BFF (bramka SMS po wygasnieciu sesji);
            // BFF usuwa pole przed forwardem do GATEWAY
            sid: window.__sid

          })
          .then(response => {


            // in case of logged in - reload state
            if (page.loggedIn){

              this.echo('login_reload');
            }


            this.log( '- VERIFY SUCCESS - ' );


            // reset isRegisterLink 
            page.isRegisterLink = false;


            page.isLoading = false;

            if (!!response.data) {

              let ok = !(response.data.IS_ERROR | 0);
              this.nextCB( ok );
            }


          })
          .catch(error => {
          //  console.log(error);


              page.isLoading = false;
              this.verifycode_hint = 'Wystąpił błąd.';

              // Error
              if (error.response) {
                  /*
                   * The request was made and the server responded with a
                   * status code that falls out of the range of 2xx
                   */
                  /*console.log(error.response.data);
                  console.log(error.response.status);
                  console.log(error.response.headers);*/

                  if (error.response.data.Message) {

                    this.verifycode_hint = error.response.data.Message.toString();
                  }
                  else if (error.response.data.MESSAGE) {

                    this.verifycode_hint = error.response.data.MESSAGE;
                  }


              } else if (error.request) {
                  /*
                   * The request was made but no response was received, `error.request`
                   * is an instance of XMLHttpRequest in the browser and an instance
                   * of http.ClientRequest in Node.js
                   */
                  //console.log(error.request);
              } else {
                  // Something happened in setting up the request and triggered an Error
                  //console.log('Error', error.message);
              }


              this.form['verifycode'] = '';
              this.$v.form['verifycode'].$touch();

            //console.log('Network error', error);

          });
        }
    },



    onSubmit( endpoint='application' ) {

      if (this.isSubmitting) return;
      if (Date.now() - this.lastSubmitTime < 3000) return;
      this.isSubmitting = true;
      this.lastSubmitTime = Date.now();

      var page = this.$root.mainpage,
        result = false,
        isRegisterLink = page.isRegisterLink;


      // set polling endpoint after main request complete
      this.waiting = this.stepForm.hasOwnProperty('__wait') ? this.stepForm.__wait : '';
      this.waitCount = 0;
      this.formErrors = false;

      // enable page loading mask if regular save or not if registerlink save
      page.isLoading = isRegisterLink ? false : ['Wysyłamy Twój wniosek...', 'Chwilę cierpliwości...'];


//console.log(this.form);


      let r, r2, basic = this.getConf('basicSubmitParams'),

      form = {},

      consents = {},
      custom = {},

      aff = localStorage.getItem('affiliate'),

      params,

      adr,
      fillSecondAddress = this.form.hasOwnProperty('client_address2_street') && !this.form['client_address2_street'];



      // affiliate params
      if (endpoint == 'application' && !!aff) {

        let utmData =  JSON.parse(aff);

        basic = {...basic, affiliate: utmData.source, affiliate_client_identity: utmData.identity};               
      }




//console.log(fillSecondAddress);

      for (let e in this.form) {

  //console.log(e);      

        if (this.form.hasOwnProperty(e)) {
          if (typeof this.form[e] == 'object' && this.form[e] !== null) {

            if (this.form[e].hasOwnProperty('value')) {

              form[e] = this.form[e].value;
            }
          }
          else {


            r = String(e).match(/consent([0-9]+)/);
            r2 = String(e).match(/custom-([0-9]+)/);

            if ( r && r.length > 1) {            

              this.form[e] == true
                && (consents[ r[1] ] = 1);
            }
            else if (r2 && r2.length > 1) {

              custom[ r2[1] ] = this.form[e];
            }
            else {


              if (fillSecondAddress) {

                adr = String(e).match(/client_address1_(.+)/);

                if ( adr ){

                  this.form['client_address2_' + adr[1]] = this.form[e];

                  form['client_address2_' + adr[1]] = this.form[e];
                }
              }


              form[e] = this.form[e];
            }

          }
        }
      }


      // Seraphin: NIE liczymy score na froncie. Backend (SeraphinScorer)
      // liczy rekomendację z surowych logów i wstrzykuje ją do custom['-23']
      // w IndexController::application() przed forwardem do GATEWAY.
      // Pole -23 celowo NIE jest tu ustawiane.

      // Korelacja Seraphina: sid trackera jedzie WEWNĄTRZ custom_fields (klucz -24),
      // nie jako pole top-level — nieznane pole top-level GATEWAY/Cashmir odrzucał
      // (IS_ERROR, dawne `params.bts`). Backend (injectBehaviorScore) konsumuje -24,
      // podmienia na rekomendację w -23 i usuwa -24 przed forwardem.
      if (window.LogService && window.LogService.getSessionId) {

        custom['-24'] = window.LogService.getSessionId();
      }


      // convert to json string
      custom = JSON.stringify(custom);


      params = {...basic, ...form, client_consents: consents, custom_fields: custom};



      // by registration link mark is_lead to 10 to update application data, amount etc..
      //if (this.activeStep > 2 && params.is_lead == 9){

      //  params.is_lead = 10;
      //}


      if (page.loggedIn) {

        params['client_id'] = page.loggedIn.client_id;
      }


      // clean spaces from nrb field
      //params.client_bank_account && (params.client_bank_account =  params.client_bank_account.split(' ').join(''));



      // clean cellphone
      params.client_cellphone && (params.client_cellphone = params.client_cellphone.split('-').join(''));

      // sid (localStorage) = klucz pliku stanu <sid>.verified zapisywanego przez
      // PATCH /verify; BFF potwierdza nim weryfikacje SMS takze po wygasnieciu
      // sesji PHP i USUWA pole przed forwardem do GATEWAY (nieznane pola top-level
      // GATEWAY odrzuca - deploy BFF przed frontem!)
      params.sid = window.__sid;

      // loan amount
      // SECURITY / anti-tamper (log 1781087182): w trybie kontynuacji/edycji
      // (__edit + loan_id) NIE wysylamy lokalnej kwoty z frontu — bo loanAmount
      // po przeladowaniu jest domyslna (schema[0].__amount) albo podmieniona
      // w devtools (loanStore.loanAmount), co pozwalalo podbic wniosek (1200 -> 3000).
      // Odtwarzamy kwote faktycznie zapisana na wznawianym wniosku z /client/loans.
      let edit = /__edit/.test(this.form.comments) && !!this.form.loan_id;

      this.ensureContinuationAmount(edit)
        .then(() => {

          if (edit && this.continuationAmount != null) {

            params.requested_amount = this.continuationAmount;
            params.requested_installments = this.continuationInstallments || 1;
          }
          else {

            params.requested_amount = this.loanAmount;
            params.requested_installments = this.tenorSign == 'm' ? this.loanTenor : 1;
          }

          this.sendApplication(endpoint, params, page, isRegisterLink);
        });
    },


    // Wysylka wniosku — wydzielone z onSubmit zeby kwote ustawic po asynchronicznym
    // odtworzeniu z /client/loans (patrz ensureContinuationAmount).
    sendApplication( endpoint, params, page, isRegisterLink ) {

      this.post( '/' + endpoint, params )
            .then(response => {

              this.isSubmitting = false;
              this.otpSubmitAfterVerify = false;

              // reload login user
              this.loggedIn && this.echo('login_reload');


//console.log('submit ok - registerlink flag is')
//    console.log(isRegisterLink)


              page.isLoading = isRegisterLink ? false : !!this.waiting;

              let ok = !(response.data.IS_ERROR | 0),
                  stage = response.data.stage || 'done';


              // log succesful form sent
              this.log( ' /' + endpoint + ' - ok, stage  ' + stage, 'request params ', this.maskSecrets(params) );



              // turn off initial flag and set next edit with status update
              /__initial/.test(this.form.comments)
              // no status update - scoreme procedure deals it
                && (this.form.comments = '__edit;__final');
               // && (this.form.comments = '__edit;__final:0.2');



              if (isRegisterLink) {

                return;
              }



              if ( !this.form.loan_id && response.data.hasOwnProperty('Message') ) {


                    this.$set(this.form, 'loan_id', response.data.Message);
                    this.$set(this.form, 'parent_id', response.data.Message);
              }



              this.nextCB( ok, stage );

            })
            .catch(error => {

              this.isSubmitting = false;
              page.isLoading = false;


              let err = error.response.data.Message,
                  dat = error.response.data;


              // bramka BFF: wniosek bez zalogowania wymaga numeru zweryfikowanego
              // kodem SMS (sesja wygasla / inny numer niz zweryfikowany) -> krok 1
              // i ponowna wysylka kodu
              if (error.response.status == 403 && !!dat && dat.VERIFY_REQUIRED) {

                this.log('- APPLICATION - BFF: wymagana weryfikacja SMS, powrot do kroku 1', dat);

                // Message = {"Numer telefonu": ["..."]} - wyciagamy tresc
                let msgs = [];
                if (err && typeof err == 'object') {
                  Object.keys(err).map(k => { msgs = msgs.concat(err[k]); });
                }
                else if (typeof err == 'string') {
                  msgs = [err];
                }

                this.pageTop();
                this.formErrors = true;
                this.invalidFields = msgs.length ? msgs : ['Wymagana ponowna weryfikacja numeru telefonu kodem SMS.'];

                // zalogowany z wygasla sesja BFF -> ponowne logowanie (GET /session -> modal)
                if (page.loggedIn) {

                  this.echo('login_reload');
                  return;
                }

                this.otpBackToStep1();
                return;
              }


              // zapis kroku 1 po weryfikacji SMS (tryb OTP) odrzucony przez GATEWAY:
              // kod jest juz zuzyty, wiec wracamy na krok 1 - user poprawia dane
              // i dostaje nowy kod
              if (this.otpSubmitAfterVerify) {

                this.log('- APPLICATION - zapis kroku 1 po weryfikacji odrzucony, powrot do kroku 1');

                this.otpBackToStep1();
              }


              // Message tekstowy (np. 403 "Konto niezweryfikowane" z BFF) - pokaz
              // tresc; petla nizej iterowalaby po literach stringa
              if (typeof err == 'string') {

                this.log('- APPLICATION - odrzucone: ' + err);

                this.pageTop();
                this.formErrors = true;
                this.invalidFields = [ err ];

                return;
              }


              if (err) {

                this.pageTop();

                this.formErrors = true;

                this.invalidFields = [];


                for (let bind in err) {


                  if (err.hasOwnProperty(bind)) {

                    this.echo('invalid_field', bind, err[ bind ].join(', '));


                    // if some field in error is not present on the form
                    !this.form.hasOwnProperty( bind ) && this.invalidFields.push( bind );
                  }
                }

                //this.verifycode_hint = error.response.data.Message.toString();

              }
              else {
                err = error.response.data;

                if (err.hasOwnProperty('PAYLOAD') && String(err.PAYLOAD).match(/do panelu/)){

                  // login to client account info
                  this.echo('next_step_fail');  
                }

              
                /*console.log("to tutaj");*/
               // 
              //console.log('Network error', error);

              }


            });

 //     console.log('Submit clicked');
    },


    // powrot na krok 1 w trybie OTP/kontynuacji, zeby user mogl poprawic dane
    // i dostac nowy kod SMS (poprzedni zuzyty albo sesja BFF wygasla)
    otpBackToStep1() {

      var page = this.$root.mainpage;

      this.otpSubmitAfterVerify = false;
      this.otpPendingSubmit = false;

      if (page.loggedIn) {

        return;
      }

      // OTP (true/0) albo wznowienie z existsapi (2): ponownie kod -> zapis kroku 1.
      // Organiczny flow (false) zostaje: quicksave -> kod -> fullform.
      if (page.isRegisterLink !== false) {

        page.isRegisterLink = true;
        this.form.comments = '__edit;__initial';
      }

      if (this.activeStep > 1) {

        this.doNextStep('quickform');
      }
    },


    // anti-tamper (log 1781087182): odtwarza kwote wznawianego wniosku z
    // autorytatywnego /client/loans (po id == loan_id). Bez tego payload w
    // trybie __edit wysylal kwote domyslna/podmieniona zamiast realnie zapisanej.
    ensureContinuationAmount( edit ) {

      if (!edit || this.continuationAmount != null) {

        return Promise.resolve();
      }

      // niezalogowany (kontynuacja OTP) — /client/loans wymaga sesji klienta
      // (BFF bez sesji zwraca 200 + []), nie wolamy. Kwote leada prefilluje FingoPage z odpowiedzi
      // OTP (prefillLeadAmount), wiec fallback do loanAmount niesie kwote
      // odtworzona z leada badz swiadomie zmieniona w kalkulatorze.
      if (!this.loggedIn) {

        this.log('- CONTINUATION - niezalogowany, /client/loans pominiete, kwota z kalkulatora');
        return Promise.resolve();
      }

      let id = String(this.form.loan_id || this.form.parent_id || '');

      return this.get('/client/loans')
        .then(response => {

          let list = Array.isArray(response.data) ? response.data : [];

          let loan = list.find(l => String(l.id) === id)
                  || list.find(l => parseFloat(l.to_be_continied) > 0);

          if (loan) {

            let amt = parseFloat(loan.net_amount != null ? loan.net_amount
                    : (loan.requested_amount != null ? loan.requested_amount : loan.pay_out_ammount)),
                inst = parseInt(loan.installments_nbr) || 1;

            if (amt > 0) {

              this.continuationAmount = Math.round(amt);
              this.continuationInstallments = inst;

              // odswiez podsumowanie/kalkulator realna kwota
              this.setValues(this.continuationAmount);

              this.log('- CONTINUATION - odtworzono kwote wniosku ' + id + ' = ' + this.continuationAmount);
            }
          }
          else {

            this.log('- CONTINUATION - brak wniosku ' + id + ' w /client/loans, kwota nie odtworzona');
          }
        })
        .catch(() => {

          // brak listy (np. brak sesji) — nie nadpisujemy; caller uzyje fallbacku
          this.log('- CONTINUATION - /client/loans niedostepne, kwota nie odtworzona');
        });
    },


    sendVerifyCodes(phone=null, email=null){


       var page = this.$root.mainpage;


        //this.$v.form['verifycode'].$touch();

        if (!!phone && !!email) {


          // numer, na ktory nie da sie wyslac SMS, nie moze przejsc dalej
          if (!this.isPlMobile(phone)) {

            this.log('- SEND VERIFY CODES - niepoprawny numer komorkowy ' + phone);

            this.otpPendingSubmit = false;
            this.pageTop();
            this.echo('invalid_field', 'client_cellphone', 'Podaj 9-cyfrowy polski numer komórkowy (bez 0 i +48 na początku)');

            return;
          }


          this.waiting = '';
          this.waitCount = 0;

          page.isLoading = true;


          let payload = {
            client_email: email,
            client_cellphone: phone,
            loan_id: this.form['loan_id'] || 0,
            sid: window.__sid
          };


          this.log('- SEND VERIFY CODES - ', 'POST /verify ', payload );


          this.post( '/verify', payload)
          .then(response => {

            page.isLoading = false;

            if (!!response.data) {

              let ok = !(response.data.IS_ERROR | 0);

//console.log(ok)

               if (ok) {

                this.timestamp = Date.now();

                //this.echo('verify_twin');
                //this.echo('verify_timestamp', this.timestamp);
                //this.echo('notify', 'Wysłano SMS oraz E-mail z kodem.');


                // set to 0 instead of bool to know that it was register by link
                this.$root.mainpage.isRegisterLink = 0;

                this.doNextStep('verifycode');
                 
              }
            }
          })
          .catch(error => {
          //  console.log(error);

              page.isLoading = false;

              // kod nie wyszedl - zadnego zapisu kroku 1
              this.otpPendingSubmit = false;

              // Error
              if (error.response) {

                let dat = error.response.data;

                if (!!dat && dat.hasOwnProperty('FOUND') ) {

                   //this.echo('existing_record');

                  this.log('- FOUND EXISTING RECORD - notify to login to profile' );
                  //this.log('- FOUND EXISTING RECORD - skip sms verify, do next step' );

                  //this.doNextStep();

                  // login to client account info
                  this.echo('next_step_fail');


                }
                else {

                  // np. 400 "No correct phone numbers" (smsapi) - dawniej polykane
                  // po cichu, user zostawal na kroku bez informacji i klikal dalej
                  let hint = (!!dat && typeof dat == 'object' && (dat.Message || dat.ERROR))
                        ? String(dat.Message || dat.ERROR).replace(/\s*\[[^\]]*\]\s*$/, '')
                        : 'Nie udało się wysłać kodu SMS. Sprawdź numer telefonu.';

                  this.log('- SEND VERIFY CODES - blad wysylki kodu: ' + hint, dat);

                  this.pageTop();
                  this.echo('invalid_field', 'client_cellphone', hint);
                }


              } else if (error.request) {

                this.log('- SEND VERIFY CODES - brak odpowiedzi /verify');
                this.echo('invalid_field', 'client_cellphone', 'Nie udało się wysłać kodu SMS. Spróbuj ponownie.');

              } else {

              }

            //console.log('Network error', error);

          });
        }
    },




    checkVerifyCodes(pcode='', ecode='') {

       var page = this.$root.mainpage;

//this.nextCB( true, 'doublestep' );
//return;

        if (!!pcode) { // && !!ecode ) {

          this.waiting = '';
          this.waitCount = 0;


          // prevent from multiple triggered verify
          //this.__verify = true;
          page.isLoading = true;



          let payload = {
            activation_code: pcode + '' + ecode,
            sid: window.__sid      
          };


          this.log('- CHECK VERIFY CODES - ', 'PATCH /verify ', payload );

          
          this.patch( '/verify', payload)
          .then(response => {

            // if postponed submit keep the mask
            page.isLoading = false;


            this.log('verify codes handler ' , response);


            if (!!response.data) {

              let ok = !(response.data.IS_ERROR | 0);


              // tryb OTP: kod poprawny -> dopiero teraz zapis kroku 1 (__initial).
              // isRegisterLink jest juz 0, wiec sendApplication po sukcesie sam
              // przelaczy comments na __final i wywola nextCB (przejscie do fullform).
              if (ok && this.otpPendingSubmit) {

                this.otpPendingSubmit = false;
                this.otpSubmitAfterVerify = true;

                this.log('- VERIFY OK - zapis kroku 1 po weryfikacji SMS (tryb OTP)');

                this.onSubmit();
                return;
              }


              this.nextCB( ok );

            }


          })
          .catch(error => {
          //  console.log(error);

              //this.__verify = false;

              page.isLoading = false;
              this.verifycode_hint = 'Wystąpił błąd.';

              // Error
              if (error.response) {
                  /*
                   * The request was made and the server responded with a
                   * status code that falls out of the range of 2xx
                   */
                  /*console.log(error.response.data);
                  console.log(error.response.status);
                  console.log(error.response.headers);*/

                  if (error.response.data.Message) {

                    this.verifycode_hint = error.response.data.Message.toString();
                  }
                  else if (error.response.data.MESSAGE) {

                    this.verifycode_hint = error.response.data.MESSAGE;
                  }


              } else if (error.request) {
                  /*
                   * The request was made but no response was received, `error.request`
                   * is an instance of XMLHttpRequest in the browser and an instance
                   * of http.ClientRequest in Node.js
                   */
                  //console.log(error.request);
              } else {
                  // Something happened in setting up the request and triggered an Error
                  //console.log('Error', error.message);
              }


          });
        }
        else {

          // turn off mask
          this.$root.mainpage.isLoading = false;
        }

    },




    existCheck(phone=null, email=null, pesel=null){

      return new Promise((resolve, reject) => {

         var page = this.$root.mainpage;


         // tryb OTP: skip lookupu jest bezpieczny TYLKO gdy email zgodny z leadem.
         // Zmieniony email moze nalezec do istniejacego konta - backend nadpisze
         // email na rekordzie leada bez walidacji unikalnosci (incydent 2026-07-07,
         // duplikat emaila), wiec taki email musi przejsc /existsapi.
         var otpEmailChanged = !!page.isRegisterLink
              && page.otpEmail != null
              && !!email && !!phone
              && String(email).trim().toLowerCase() != page.otpEmail;


         if ((!!this.form['loan_id'] || page.isRegisterLink) && !otpEmailChanged){

          resolve('exist check skip');
          return;
         }




          if (!!phone && !!email) {

            // personal loans so skip nip param by setting to int 0, other values are validated as error
            let nip = pesel || 0,
                query = [email,phone,nip].join('/');


            this.log('- EXIST CHECK - ', 'GET /existsapi/', query);


//console.log('mask ON')

            page.isLoading = true;


            this.get( '/existsapi/' + query)
            .then(response => {

              // Brak leada: nowy backend zwraca 204 / pustą odpowiedź (NIE error).
              // Axios traktuje 204 jako sukces (.then) z response.data === '' —
              // dlatego łapiemy też pusty string / pusty obiekt / pustą tablicę,
              // inaczej Promise nigdy się nie rozwiąże i wniosek wisi.
              var d = response.data;
              var isEmpty = d === null || d === undefined || d === ''
                || (typeof d === 'object' && Object.keys(d).length === 0);

              if (isEmpty) {

                this.log('- EXIST CHECK - brak leada (puste/204) → kontynuuj wniosek');
                resolve(null);
                return;
              }

              if (!!response.data) {

                let dat = response.data,

                    ok = !(dat.IS_ERROR | 0);
  //console.log(ok)

                 if (ok) {

                  // tryb OTP ze zmienionym emailem: klient/wniosek istnieje dla
                  // wpisanego emaila - nie wznawiamy i nie kontynuujemy leada,
                  // tylko wymagamy zalogowania na istniejace konto
                  if (otpEmailChanged) {

                    this.log('- EXIST CHECK - email zmieniony w trybie OTP nalezy do istniejacego klienta - wymagane logowanie');

                    page.isLoading = false;

                    // login to client account info (modal jak przy 400 "Zaloguj sie do panelu")
                    this.echo('next_step_fail');

                    reject(dat);
                    return;
                  }

                  // found application to continue so setup fields
                  if (dat.hasOwnProperty('internet_loan_request_id') && !!dat.internet_loan_request_id) {


                    this.log('- EXIST CHECK - application resumed - loan_id ' + dat.internet_loan_request_id );

                    this.$set(this.form, 'loan_id', dat.internet_loan_request_id);
                    this.$set(this.form, 'parent_id', dat.internet_loan_request_id);
                    this.form.is_lead = 9;

                    // indicate continue of application but skip first page
                    this.$set(this.form, 'comments', '__edit;__final');

                    // finally set flag as register by link to continue like otp, set value 2 to indicate to skip first step /application
                    page.isRegisterLink != 3 && (page.isRegisterLink = 2);
                  }

                  resolve(dat);
                  return;
                }
                else {

                  reject(dat);
                  return;
                }
              }

            })
            .catch(error => {
            //  console.log(error);

                

                // Error
                if (error.response) {


                  let dat = error.response.data;


                  if (!!dat && dat.hasOwnProperty('Message') && /Data not found/.test(dat.Message) ) {  

                    resolve(dat);
                    return;                    
                  }


                  reject(dat);
                  return;

                } 


                reject(error);

              //console.log('Network error', error);

            });
          }
      });

    },






    onWaiting( endpoint='application' ) {


      var page = this.$root.mainpage,
          step,


        poll = () => {

          var seconPoll =  setTimeout(poll, 5000);

          // 3 sek * 120 = 6 min
          if (this.waitCount > 30){

            page.isLoading =false;

            // timeout page
            this.routeToStage('pending');
            return;
          }

          this.waitCount++;



          this.get( '/' + endpoint + (!this.form['parent_id'] ? '' : '/' + this.form['parent_id']) )
              .then(response => {

                clearTimeout(seconPoll);


                if (!!response.data) {

                  step = response.data.hasOwnProperty('step') ? response.data.step : '';


                  switch (step) {

                    case 'wait':
                      break;

                    case 'reject':
                      page.isLoading=false;
                      this.routeToStage('reject');
                      return;

                    case 'transactionlink':

                      page.isLoading=false;
                      page.loanId = response.data.loan_id;
                      
                      this.routeToStage('transactionlink');
                      return;


                    case 'kontox':

                      page.isLoading =false;

                      this.doNextStep('kontox');
                      return;

                    case 'counteroffer':
                      page.isLoading =false;
                      this.routeToStage('proposal', response.data);
                      return;

                    case 'not defined':
                      //console.log('not definedd');

                      page.isLoading =false;
                      this.nextCB( true, 'pending' );
                      return;

                    case 'authologic_start':
                      page.isLoading=false;

                      window.location = response.data.step_details;
                      return;

                    case 'easycheck':
                      page.isLoading=false;
                      window.location = response.data.step_details;
                      return;

                    case 'amodit':
                      page.isLoading=false;

                      window.location = response.data.step_details;
                      return;

                    default:
                      page.isLoading =false;
                      this.nextCB( true );
                      return;
                  }

                }
                else {

                  //console.log('status reutrned an empty response')
                  this.log('- onWait status returned empty response');
                }


                // dispatch another poll request
                page.isLoading
                    && setTimeout(poll, 5000);


              })
              .catch(error => {


                  // wait fot timeout insted
                  //page.isLoading = false;
                  setTimeout(poll, 5000);

                  // Error
                  if (error.response) {


                  } else if (error.request) {

                  } else {
                      // Something happened in setting up the request and triggered an Error
                      //console.log('Error', error.message);
                  }
              });


        };


        // initial polling
        setTimeout(poll, 5000);
    },



    routeToStage(stage='thankyou', data=null) {


      switch (stage) {

        case 'done':
          this.$router.push({path: 'thankyou'});
          break;


        case 'transactionlink':
          this.$router.push({path: 't10l'});
          break

        case 'pending':
          this.$router.push({path: 'pending'});
          break;

        case 'step_details':
          this.$router.push({path:'step_details'});
          break;

        case 'client':
          this.$router.push({path:'client'});
          break;        


        case 'proposal':

          this.finishDate = data.last_installment_date.split(' ')[0].replace(/([0-9]{4})-([0-9]{2})-([0-9]{2})/, '$3.$2.$1');
          this.setValues(data.net_amount);


          this.$router.push({path: 'proposal'})
                .then(  () => {

                  //bus.$emit('proposal_amount', data);

                })
                .catch(() => {});

          break;


        case 'reject':
          this.$router.push({path: 'rej'});
          break




        default:

          this.$router.push({path: 'thankyou'});
      }
    },





    filldebug($ev) {

        this.echo('filldebug');
    },


    // next callback
    nextCB(result=false, stage='done') {

      var page = this.$root.mainpage;

      if (!page.isLoading) {
        this.waiting = false;
        this.waitCount = 0;
      }

      // bad request
      if (!result){
        //error message here
        return;
      }



      if (!this.waiting) {

        if (this.activeStep < this.steps) {

          this.doNextStep();
        }
        else {

          this.routeToStage( stage );
        }
      }
      else {

        this.onWaiting( this.waiting );
      }

    },


    next($ev) {

//console.log(this.stepForm);


      //  check if started application exist
      // in case of already started application by api or portal, check to continue with started loan_id
      this.existCheck(this.form['client_cellphone'], this.form['client_email'], this.form['client_PESEL'])

      .then(response => {


        this.log('EXIST CHECK OK', ' details ', response);



        if (this.$root.mainpage.isRegisterLink && this.$root.mainpage.isRegisterLink < 3){

          // SECURITY (incydent 2026-10-07, PESEL 76060710218): dawniej krok 1 szedl
          // do GATEWAY (onSubmit) PRZED wysylka kodu SMS - zmieniony numer telefonu
          // nadpisywal kartoteke bez weryfikacji, a nieudana wysylka (400 z smsapi)
          // nie blokowala dalszych submitow. Teraz: najpierw kod, zapis kroku 1
          // dopiero po poprawnym kodzie (checkVerifyCodes -> onSubmit).
          // Wartosc 2 (wznowienie z existsapi) = krok 1 pomijany, jak dotad.
          this.otpPendingSubmit = this.$root.mainpage.isRegisterLink < 2;


          this.sendVerifyCodes(this.form['client_cellphone'], this.form['client_email']);




          return;
        }


        // CURRENT STEP
        // chcek if current step is posting data

        if (this.stepForm.hasOwnProperty('__endpoint')) {


console.log('submitted');

          this.onSubmit(this.stepForm.__endpoint.trim());

          // above async so return so far, continue with callback
          return;

        }

        else if (this.specialStep == 'verifycode') {


          // sms verify by register link 
          if (this.$root.mainpage.isRegisterLink === 0) {


            this.checkVerifyCodes(this.form.verifycode);

          }
          else {

            this.verifyCode();
          }

          // above async so return so far, continue with callback
          return;
        }
        // END CURRENT STEP



        this.doNextStep();

      })

      // exist check not resolved
      .catch(error => {


        this.$root.mainpage.isLoading = false;

        this.log('EXIST CHECK ERROR', ' details ' );

      });

    },


    doNextStep(goto=''){


      if (!!goto) {

        let stage = ['quickform','verifycode','fullform'].indexOf( goto );


        if (stage > -1) {

          this.activeStep = stage;
        }
        else {
          let as = 0;
          this.schema.map( s => {

            if (s.hasOwnProperty('__goto')) {

              if (s.__goto == goto) {

                this.activeStep = as;
              }
            }

            as++;
          });
        }

//console.log(stage);

      }




      // GO TO NEXT STEP
      if (this.schema[this.activeStep]) {

        let step = this.schema[this.activeStep];



        if (step.hasOwnProperty('__goto')) {

            switch (step.__goto) {

              case 'kontox':


                //this.$router.push({path: 'kontox'});
                // index.js
                embedKontomatik({
                  client: this.getConf('kontomatikClient' + (this.debug == 'on' || this.tests == 'on' ? 'Test' : '')),  // replace it with your assigned client id
                  divId: 'kontox',       // must match the div element id
                  locale: 'pl',       // ui language
                  onSuccess: (target, sessionId, sessionIdSignature, options) => {
                    // End-user successfully signed in to the bank
                    // Pass target, sessionId and sessionIdSignature to your backend
                    //alert('It works!');

                    this.postKontoxData({
                      "session_id": sessionId,
                      "session_id_signature": sessionIdSignature,
                      "internet_loan_request_id": this.form.loan_id
                    });
                  }
                });

                break;

            }


            // scroll to top with .5s delay
            this.pageTop();
        }

        //else {

  //console.log($ev)

          this.activeStep++;


          // full form visible
          if (this.activeStep == 3 ) {

            this.log('- FULL FORM - mask is ' + (this.$root.mainpage.isLoading ? 'ON' : 'OFF'));
          }
        //}
      }
    },





    prev() {

      this.activeStep--;


      // in case of register by link have to reset flag to 1 if user goes back to step 1
      if (this.activeStep == 1 && this.$root.mainpage.isRegisterLink === 0) {

        // reset flags
        this.form.comments = '__edit;__initial';


        this.$root.mainpage.isRegisterLink = true;
      }


    },


    testroute() {



/*

let dt = {"status_name":"Kontroferta","color":"blue","icon":"thumbs-up","step":"counteroffer","net_amount":"1000.0000","gross_amount":".00","interest_amount":"6.0000","loan_date":"2021-09-26 00:00:00.000","last_installment_date":"2021-10-26 00:00:00.000","lead_id":"1006","loan_id":"517","client_id":"360","status_id":".40","pay_out_type":"1","reject_reason":null,"contract_nbr":" UM-353\/09\/2021","agent_id":"2","installments_nbr":"1","installment_amount":"1280.00","initial_payment":"0","insurance_amount":".0000","service_fee":".0000","loan_status_date":"2021-09-26 16:03:48.077"};




this.routeToStage('proposal', dt);


*/

      //console.log(this.$root);


     // let page = this.$root.mainpage;



//window.scrollTo(0,0)


//document.documentElement.style.overflow = 'hidden';


/*var del = document.documentElement,

top = del.scrollTop;



console.log(top);


window.addEventListener('scroll',  function(){

console.log(top)
 // del.scrollTop = top;


  window.scrollTo(0, top);


}, false);
*/






//document.body.style.overflow='hidden';

//console.log(document)




/*
      this.$router.push({path: '/proposal'})
      .then(  () => {


        bus.$emit('proposal_amount', 950);

      })
      .catch(() => {});


*/

      this.page.isLoading = true;

      /*setTimeout(() => {



        nau.isLoading = false


        this.$router.push({path: 'kontox'});


      }, 3000)*/



    },



    fillUp(item){


//console.log('fill item ' + item);



      return this.fmap.hasOwnProperty(item) && this.echo('fill_up', item, this.page.loggedIn[ this.fmap[item] ]) || this.page.loggedIn.hasOwnProperty(item) && this.echo('fill_up', item, this.page.loggedIn[ item ]);
    },



    fillForm(){


      if (!this.page.loggedIn) {
        return;
      }

      this.delayedTask = null;

      let get = n => this.page.loggedIn[ n ],

          skipEmpty = k => /client_identity|client_education|client_civil|client_PESEL|client_address2/.test(k) && ( !get(this.fmap[k]) || !String(get(this.fmap[k])).trim() || (/_date/.test(k) && /1970-01.01|1900-01-01/.test(get(this.fmap[k]))) );


/*      Object.keys(this.stepForm).map( k => {

        if (k.match(/^__row/)) {

          Object.keys(this.stepForm[k]).map( sk => {

            this.fillUp(sk);
          });
        }
        else {
          this.fillUp(k);ó
        }
      });*/


      // special fill ups - second address, consents, polish citizen check
      //this.echo('fill_up', 'country', 1);



      // extract custom fields
      get('custom_fields') && get('custom_fields').split(',').map( el => this.$set(this.form, el.split(':')[0].trim(), el.split(':')[1].trim()) && this.echo('fill_up', el.split(':')[0].trim(), el.split(':')[1].trim()) );


      

      Object.keys(this.fmap).map( k => {
        if (skipEmpty(k)) return;
        let val = get(this.fmap[k]);
        if (/client_costs|client_employment_income/.test(k) && val !== null && val !== undefined && val !== '') {
          val = Math.round(parseFloat(val));
        }
        if (/client_citizenship/.test(k)) {
          val = 'Polska';
        }
        this.$set(this.form, k, val);
      });










      // saved model from 1st step
/*      this.form = {...this.form,


        client_citizenship: 'Polska',
        client_household_size: !parseInt(this.page.loggedIn['household_size']) ? 1 : this.page.loggedIn['household_size'],


        client_name: this.page.loggedIn['name'],
        client_surname: this.page.loggedIn['surname'],
        client_email: this.page.loggedIn['email'],
        client_cellphone: this.page.loggedIn['cellphone'],
        client_PESEL: this.page.loggedIn['pesel'],
        client_address1_city: this.page.loggedIn['city1'],
        client_address1_street: this.page.loggedIn['street1'],
        client_address1_building: this.page.loggedIn['building1'],
        client_address1_flat_nbr: this.page.loggedIn['flat1'],
        client_address1_postal_code: this.page.loggedIn['postal_code1'],
        client_address2_city: this.page.loggedIn['city2'],
        client_address2_street: this.page.loggedIn['street2'],
        client_address2_building: this.page.loggedIn['building2'],
        client_address2_flat_nbr: this.page.loggedIn['flat2'],
        client_address2_postal_code: this.page.loggedIn['postal_code2']
      };*/



      this.fillDone = true;
    }



  },



  created() {


//console.log('created')



    this.page = this.$root.mainpage;

/*    this.fmap = {
        client_name:                        'name',
        client_surname:                     'surname',
        client_citizenship:                 'citizenship',
        client_identity_card:               'identity_card',
        client_birth_date:                  'birth_date',
        client_identity_card_expiry_date:   'identity_card_expiry_date',
        client_identity_document_type:      'identity_document_type',
        client_address1_street:             'street1',
        client_address1_city:               'city1',
        client_address1_flat_nbr:           'flat1',
        client_address1_building:           'building1',
        client_address1_postal_code:        'postal_code1',
        client_address2_street:             'street2',
        client_address2_city:               'city2',
        client_address2_flat:               'flat2',
        client_address2_building:           'building2',
        client_address2_postal_code:        'postal_code2',
        client_education:                   'education_type_id',
        client_civil_state:                 'civil_state_id',
        client_employment_type:             'income_type_id',
        client_employer_name:               'company_name',
        client_household_size:              'household_size'


      };*/



      this.fmap = this.getConf('fields_mapping');


   // console.log(__CFG)


//console.log(this.page)



   let uri = window.location.href.split('?');


   // uri parameters
   if (uri.length > 1) {
    this.uri = uri[1];
   }

   //console.log(uri);


   if (uri.length > 1 && /amount=[0-9]+/.test(uri[1]) ) {


      let reg = uri[1].match(/amount=([0-9]+)/);

      this.loanAmount = reg[1];
   }



/*
   // register by link
   if (uri.length > 1 && !this.isRegisterLink && /register=(.+)#/.test(uri[1]) ) {


    // prevent default form buildup
    this.activeStep = 0;

    this.isRegisterLink = true;
    this.page.isRegisterLink = true;


    let reg = uri[1].match(/register=(.+)#/),

      goVerify = () => {

        console.log('go verify run ' + (this.configLoaded ? 'loaded' : ''))

        if (this.configLoaded) {

          console.log('got config so go to verifycode')



          this.doNextStep('verifycode');
        }
        else {

          console.log('set timeout to verifycode');

          setTimeout(goVerify, 500);

        };
      };



      this.get('/application/otp/' + reg[1] )

        .then(response => {


          if (!!response.data) {

            let ob = response.data;


            
            this.page.loggedIn = {
      //        "client_id":                              ob.client_id,
              "client_name":                            ob.client_first_name + ' ' + ob.client_surname,
              "pesel":                                  ob.client_pesel,
              "name":                                   ob.client_first_name,
              "surname":                                ob.client_surname,
              "middlename": "",
              "maiden_name": "",
              "citizenship":                            "Polska",
              "birth_date": "",
              "identity_card":                          ob.client_identity_card,
              "telephone": "",
              "cellphone":                              ob.client_cellphone,
              "email":                                  ob.client_email,
              "identity_card_expiry_date":              ob.client_identity_card_expiry_date,
              "street1":                                ob.client_address1_street,
              "building1":                              ob.client_address1_building_nbr,
              "flat1":                                  ob.client_address1_flat_nbr,
              "postal_code1":                           ob.client_address1_postal_code,
              "city1":                                  ob.client_address1_city,
              "residence_time_at": "0",
              "property_type_name": null,
              "street2":                                ob.client_address2_street,
              "building2":                              ob.client_address2_building_nbr,
              "flat2":                                  ob.client_address2_flat_nbr,
              "postal_code2":                           ob.client_address2_postal_code,
              "city2":                                  ob.client_address2_city,
              "civil_state_id":                         ob.client_civil_state.replace(/\\/, ''),
              "civil_state": "",
              "income_type_id":                         ob.client_employment_type,
              "company_name": "",
              "company_nip": "",
              "client_post": "",
              "client_employment_description": "",
              "client_employment_income":               ob.client_employment_income,
              "company_street": "",
              "company_building_nbr": "",
              "company_flat_nbr": "",
              "company_telephone": "",
              "company_postal_code": "",
              "company_city_name": null,
              "bank_name": "",
              "client_bank_account":                    ob.client_bank_account,
              "requests_no": "0",
              "completed_loans_no": "0",
              "block_days_left": "0",
              "civil_state_name": "",
              "education_type_id":                      ob.client_education,
              "education_type_name": "",
              "is_using_social_media": "0",
              "credit_history_score": null,
              "document_type_name": "Dowód osobisty",
              "client_NIP": "",
              "active_loan_no": "0",
              "rejected_loan_no": "0",
              "client_dependents_number": "0",
              "client_employment_start": null,
              "client_costs":                           ob.client_costs,
              "client_commitments": ".0000",
              "verified": "1"
            };



//console.log(this.page.loggedIn);


            this.form.client_email = response.data.client_email;

            goVerify();

          }

        })
        .catch(error => {
          console.log('Network error', error);
        });

   }*/




    // initial amount set
    this.setValues(this.loanAmount);



    this.listen('logout', () => {

      this.doNextStep('quickform');

      // clear form
      //this.form = {};
      // better way - no console red wall
      this.form = new Object();
    });

//console.log('fees as folows  ' + this.service + ' ' + this.interest);


    this.listen('calc_edit_done', () => {



            // invalid fomr
      if (this.$v.form.$invalid) {

        // mark fields as touched to highlight invalid ones
        this.$v.form.$touch();

        // scroll to top
        this.pageTop();

//console.log(this.$v)
        return;
      }


      // link up with next button
      this.next();


/*      if (this.editMode !== 'persist') {

        this.editMode = false;
      }*/
    });


    // dynamic validations
    this.listen('dynamic_validation', (bind, enabled) => {


      // remove if not set
      if (!enabled && this.dynamicValidation.hasOwnProperty(bind)){

        delete this.dynamicValidation[ bind ];
      }

      // iterate current form
      Object.keys(this.stepForm).map( k => {
        if (k.match(/^__row/)) {
          Object.keys(this.stepForm[k]).map( sk => {

            sk == bind && !!enabled
              && (this.dynamicValidation[ sk ] = this.stepForm[k][sk]);
          });
        }
        else {

          k == bind && enabled
            && (this.dynamicValidation[ k ] = this.stepForm[k]);
        }
      });


      // force vue to re-apply validations
      this.dynamicValidation = {...this.dynamicValidation};

    });


    // client session id for quicksave and full form
    if (!this.page.uuid) {

      //this.page.uuid = window.__sid || uuidv4();   

      // new session every time, cause different users can use the same device
      this.page.uuid = uuidv4();      
    }


    this.form['external_id'] = this.page.uuid;




    if (__form_config) {

      this.schema = __form_config;
      this.steps = this.schema.length;
    }



    this.get( '/config' + (!uri[1] ? '' : '?' + uri[1]), null, {
          baseURL: this.getConf('secondaryEndpoint')
        } )
        .then(response => {



          // in case not loaded locally
          if (!this.schema) {

            this.schema = response.data;
            this.steps = this.schema.length;
          }



          //this.debug = this.schema.length > 0 && this.schema[0].hasOwnProperty('__endpoint') && this.schema[0].__endpoint[0] == ' ';


          // default amount
          if (this.schema.length > 0 && this.schema[0].hasOwnProperty('__amount') && !String(uri[1]).match(/amount/) ) {

            this.setValues(this.schema[0].__amount, this.getConf('default_tenor'), this.getConf('tenor_sign'));
          }


          this.isFilled = this.page.loggedIn && this.steps > 0;

        })
        .catch(error => {
          console.log('Network error', error);
        });






        // transactionlink workflow token
        this.get( '/transactionlink/' + this.page.uuid )
        .then(response => {

          if (!!response.data) {

            this.form['workflow_token'] = response.data;


            this.page.party_id = this.page.uuid;
            this.page.workflow_token = this.form['workflow_token'];



    //console.log('workflow token is ' + response.data);        
          }
        })
        .catch(error => {

          console.log('workflow token error', error);
        });


        


  },


  mounted() {



  },



  updated() {

    var page = this.$root.mainpage;

    if (page.isLoading) {
      return;
    }


//console.log('updated form ')
//console.log(this.$router.currentRoute.path);


    // logged in so redirect to fullform
    if ( this.activeStep == 1 && this.steps > 0 && this.page.loggedIn ) {


      if ( this.uri.match(/verify/) ) {

        this.uri = '';
        page.isLoading = true;


//console.log(' go verify');

/*setTimeout(()=>{

page.isLoading = false;
this.doNextStep('verifycode');

}, 1220)*/



        this.patch('/activate')

          .then(response => {

            page.isLoading = false;

            // init form data
            if (!this.form.client_email) {

                this.$set(this.form, 'client_cellphone', this.page.loggedIn.cellphone );
                this.$set(this.form, 'client_email', this.page.loggedIn.email );


                // fill the rest form data in case of continue application
                setTimeout(this.fillForm, 800);
            }


            // set this flag to prevent sending secondary codes after existcheck
            page.isRegisterLink = 3;


            this.doNextStep('verifycode');
            
          })
          .catch(error => {

            page.isLoading = false;

            //console.log('Network error', error);
          });
        
      }
      else {

//console.log(' no verify');

        // check if user is verified or has blocking status
        !this.canApplyForLoan(this.page.loggedIn) ? this.routeToStage('client') : this.doNextStep('fullform');
                
      }
    }


    // go to fullform step and fill data
    if (this.page.loggedIn && typeof this.page.loggedIn == 'object' && parseInt(this.page.loggedIn.verified) == 1 && this.steps > 0 && !this.fillDone ) {


      if (this.delayedTask) {

        this.delayedTask = clearTimeout(this.delayedTask);
      }


      this.delayedTask = setTimeout(this.fillForm, 800);

    }



  }
}
</script>


<style >
/*
#form-wrapper h2 {
  font-size: 1.6rem;
}


ul.form-steps {
  list-style: none;
  display:flex;
  justify-content: center;

  margin-bottom:2rem;
}

ul.form-steps li {
  display: list-item;
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
  border-radius: 100%;
  background: #d8d8d8;
  margin-right: 3rem;
  position: relative;
  font-size:.9rem;
  text-align:center;
}

ul.form-steps li:last-child {

  margin-right:0;
}

ul.form-steps li:first-child {
  margin-left: unset;
}

ul.form-steps li:first-child:before {
  display: none;
}

ul.form-steps li:before {
  content: "";
  width: 3rem;
  background-color: #d8d8d8;
  height: 2px;
  position: absolute;
  top: 1rem;
  right: 1.9rem;
}

ul.form-steps .active {
  background: #0bc268;
  color: #fff;
}

ul.form-steps .active:before {
  background-color: #0bc268;
}


.form-btn-wrap {

  margin-top: .5rem;
  padding: 2rem 1rem;

  display: flex;
  justify-content:flex-end;
}

.main-form .button {

    cursor:pointer;
    min-width:260px;
    font-size: 16px;
    padding: 16px 40px;
    transition: ease-out 1s;
    line-height: 16px;

    border-radius:10px;
    border:0px;

    margin: 0 .5rem;

}

.main-form .button:disabled {
  cursor:not-allowed;
  opacity: .7;
}


.form-button.btn.disabled {
  background-color: #045439;
}


.main-form .button.btn-next, .main-form .button.btn-submit {

  background-color: #0bc268;
  color: #fff;
}

.main-form .button.btn-next:hover, .main-form .button.btn-submit:hover {
  box-shadow: inset -400px 0 0 0 #007666;
}


.main-form .button.btn-prev {

  background-color: #dfdfdf;
  color: rgb(64, 64, 64);
}

.main-form .button.btn-prev:hover {
  box-shadow: inset -400px 0 0 0 #bebebe;
}


.main-form .form-input {

  transition: all 0.2s ease-in-out;
  border-radius:10px;
  min-height: 30px;
  padding:10px;
  color: #404040;
  border: 1px solid #ccc;
  font-weight:600;
  font-size:16px;
  height:auto;
}

.main-form .form-input:focus {
  -webkit-box-shadow: 0 12px 30px rgba(0,0,0,.07);
  box-shadow: 0 12px 30px rgba(0,0,0,.07);
}








.button {

    cursor:pointer;
    min-width:220px;
    font-size: 16px;
    padding: 16px 40px;
    transition: ease-out 1s;
    line-height: 16px;

    border-radius:30px !important;
    border:0px;

    margin: 0 .5rem;

}

.button.disabled {
  cursor:not-allowed;
  opacity: .7;
}

.button.btn-prev {

  background-color: #dfdfdf;
  color: rgb(64, 64, 64);
}

.button.btn-prev:hover {
  box-shadow: inset -400px 0 0 0 #bebebe;
}



.button.btn-next, .button.btn-submit, .button.btn-next.disabled {

  background-color: #f79949 !important;
  color: #fff;
}

.button.btn-next:hover, .button.btn-submit:hover {
  box-shadow: inset -400px 0 0 0 #f57e18;
}


*/


</style>



// WEBPACK FOOTER //
// src/DynamicForm.vue